import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OperatingCarrier } from 'src/app/core/models/voluntary-change.model';

@Component({
  selector: 'app-search-airline-false',
  templateUrl: './search-airline-off.component.html'
})
export class SearchAirlineOffComponent implements OnInit {
  @Input() selectedAirline: OperatingCarrier;
  @Input() airlines: OperatingCarrier[];
  @Input() placeholder: string;
  @Input() label: string;
  @Input() errorMessage: string;
  @Input() submitted: boolean;
  @Input() disabled: boolean;
  @Output() selectedAirlineChange = new EventEmitter<OperatingCarrier>();

  list: any[];
  selectedListItem: any;

  constructor() { }

  ngOnInit(): void {
    this.list = this.airlines.map(this.getListItem);
    this.selectedListItem = this.getListItem(this.selectedAirline);
  }

  getListItem(airline: OperatingCarrier) {
    if (!airline) { return null; }
    return {
      ...airline,
      label: `${airline.code || ''} - ${airline.name || ''}`
    }
  }

  emitSelectedAirline() {
    this.selectedAirlineChange.emit({
      code: this.selectedListItem.code,
      name: this.selectedListItem.name
    });
  }

}
